import * as React from "react";
import { cn } from "@/lib/utils";

interface LoadingSpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "md" | "lg" | "xl";
  label?: string;
}

const sizeClasses = {
  sm: "h-4 w-4 border-2",
  md: "h-6 w-6 border-2",
  lg: "h-8 w-8 border-3",
  xl: "h-12 w-12 border-4",
};

export function LoadingSpinner({ size = "md", label, className, ...props }: LoadingSpinnerProps) {
  return (
    <div
      role="status"
      aria-label={label || "Loading"}
      className={cn("flex flex-col items-center justify-center gap-3", className)}
      {...props}
    >
      <div
        className={cn(
          "animate-spin rounded-full border-primary/30 border-t-primary",
          sizeClasses[size]
        )}
      />
      {label && <p className="text-sm text-muted-foreground animate-pulse">{label}</p>}
      <span className="sr-only">{label || "Loading"}</span>
    </div>
  );
}

interface LoadingOverlayProps extends LoadingSpinnerProps {
  fullScreen?: boolean;
}

export function LoadingOverlay({
  fullScreen = false,
  size = "lg",
  label,
  className,
  ...props
}: LoadingOverlayProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-center",
        fullScreen ? "fixed inset-0 z-50 bg-background/80 backdrop-blur-sm" : "py-12",
        className
      )}
      {...props}
    >
      <LoadingSpinner size={size} label={label} />
    </div>
  );
}
